'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactVersion = require('./reactVersion');

var _utils = require('./utils');
/**
 * Determines if the object is a React component.
 *
 * @param   {React.Component} Component A React.Component.
 * @returns {boolean} Truthiness.
 */


function isReactComponent(Component) {
  // Stateless functional components
  if ((0, _utils.isFunction)(Component)) {
    return true;
  } else if ((0, _utils.isObject)(Component)) {
    return (0, _reactVersion.isReact15Up)(Component) || Component.hasOwnProperty('$$typeof') || Component.hasOwnProperty('ref');
  }

  return false;
}

exports.default = isReactComponent;